import React from 'react';
import { Controls, MiniMap } from 'reactflow';
import { Plus } from 'lucide-react';
import { activityToolbarButtonClass } from 'features/activity/styles/dataTableStyles';

/**
 * Zoom, fit and (past a few steps) a minimap, in the theme's tokens: the look
 * is in editor.css, so there is nothing to restyle here.
 */
export default function CanvasControls({ showMiniMap, onFit }) {
  return (
    <>
      <Controls position="bottom-left" showInteractive={false} onFitView={onFit} />
      {showMiniMap && <MiniMap position="bottom-right" pannable zoomable style={{ width: 120, height: 80 }} />}
    </>
  );
}

/** "Add step" at the bottom centre. Neutral: Publish stays the one primary. */
export function AddStepButton({ onClick }) {
  return (
    <div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2">
      <button type="button" onClick={onClick} className={`${activityToolbarButtonClass} shadow-token-sm`}>
        <Plus className="h-3.5 w-3.5" />Add step
      </button>
    </div>
  );
}
